'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$32(evaluator$34) {
  this.LB = null;
  this.LB = evaluator$34;
}
export { $c_Lsamples_Persons$package$$anon$32 as $c_Lsamples_Persons$package$$anon$32 };
$p = $c_Lsamples_Persons$package$$anon$32.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$32;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$32() {
}
export { $h_Lsamples_Persons$package$$anon$32 as $h_Lsamples_Persons$package$$anon$32 };
$h_Lsamples_Persons$package$$anon$32.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LB.h();
  return ((v instanceof $j_java$002elang$002e$002dObject.$c_s_Option) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$32 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$32, "samples.Persons$package$$anon$32", ({
  pO: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$32 as $d_Lsamples_Persons$package$$anon$32 };
